import { render, staticRenderFns } from "./ReceiptRewardDonutChart.vue?vue&type=template&id=2e860a8e&scoped=true"
import script from "./ReceiptRewardDonutChart.vue?vue&type=script&lang=js"
export * from "./ReceiptRewardDonutChart.vue?vue&type=script&lang=js"
import style0 from "./ReceiptRewardDonutChart.vue?vue&type=style&index=0&id=2e860a8e&prod&scoped=true&lang=css"
import style1 from "./ReceiptRewardDonutChart.vue?vue&type=style&index=1&id=2e860a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e860a8e",
  null
  
)

export default component.exports